module.exports = "/_next/static/files/37d13d06962b5550bac2b0a327bc8be5.png";